<template>
    <modal
    name="modal-home-category-step2"
    height="auto"
    width="70%"
    class="customSurveyModal"
    :scrollable="true"
    @before-open="beforeOpen"
    @closed="closed">

        <div class="row7">
            <header class="modalHeader flex flexAlignS homeCategoryStepHead">
            <div class="title">
                <div class="flex">
                    <p class="step">2단계</p>
                    <p class="steptitle">고령친화제품 - 실내</p>
                </div>
                <p class="infoTxt">
                    장소를 선택해주세요.
                </p>
            </div>
            <button @click="closed"></button>
            </header>
        </div>

        <div class="homeCategorybody">
            <div class="placeSelectBox">
                <button v-for="(place, index) in placeList" :key="index" :class="{selected: selectedPlaceList.indexOf(place.IDX) > -1}" @click="selectPlaceCategory(place.IDX)">
                    <figure>
                        <img :src="require('../../assets/images/cmmnMain/CategoryStep/'+place.DETAIL_IMAGE)" v-bind:alt="place.NAME">
                        <figcaption>{{place.NAME}}</figcaption>
                    </figure>
                </button>
            </div>
        </div>
        
        <div class="modalFooterBtn btnBox leftPosition">
            <p class="redBtnP" @click="closed">
                <img src="../../assets/images/cmmnMain/CategoryStep/Chevron_Right.png" alt="">
                이전 화면으로 가기
            </p>
        </div>

        <div class="searchResultCon popupCon">
            <div class="searchResultTitle">
                <p>검색결과 : 총
                    <span>
                        {{totalCnt}}
                    </span>
                    건
                </p>
            </div>
            <hr>
            <div class="searchResultBody">
                <router-link v-for="(product, index) in items" :key="index" :to="'/productDetail/'+product.CATEGORY_IDX+'/'+product.PRODUCT_IDX">
                    <div class="searchResultItem">
                        <div class="imgBox">
                            <img :src="product.MAIN_FILE" alt="">
                        </div>
                        <div class="title">
                            <p>
                                {{product.CATEGORY_NAME}}
                            </p>
                        </div>
                        <div class="subContent">
                            <table>
                                <tbody>
                                    <tr>
                                        <th>제조구분</th>
                                        <td>{{getManufactureText(product.MANUFACTURE)}}</td>
                                    </tr>
                                    <tr>
                                        <th>업체명</th>
                                        <td>{{product.COMPANY}}</td>
                                    </tr>
                                    <tr>
                                        <th>제품명</th>
                                        <td>{{product.NAME}}</td>
                                    </tr>
                                    <tr>
                                        <th>사용제안공간</th>
                                        <td>
                                            <p>
                                                {{product.PLACE_NAME}}
                                            </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </router-link>
            </div>
        </div>

        <div class="tableContainer">
            <div class="sampleTemplate">
                <paginate
                    v-model="currentPage"
                    :page-count="navCnt"
                    :page-range="3"
                    :margin-pages="2"
                    :click-handler="onClickPagenation"
                    :prev-text="'‹'"
                    :next-text="'›'"
                    :container-class="'pagination b-pagination newPagination'">
                </paginate>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'ModalHomeCategoryStep2',
    data(){
        return{
            modalResult: false,
            inOut: "실내",
            placeList : [],
            selectedPlaceList : [],
            items : null,
            totalCnt: 0,
            currentPage: 1,
            sortBy: 'IDX',
            sortDesc: false,
            perPage: 6
        }
    },
    watch:{
        selectedPlaceList(){
            this.currentPage = 1;
            this.getProduct();
        }
    },
    computed:{
        navCnt : function(){            
            if(this.totalCnt % this.perPage == 0) return this.totalCnt/this.perPage
			else return Math.floor(this.totalCnt/this.perPage) + 1;
        },
    },
    mounted(){
        this.show();

        this.requestGetPlaceListByInOut(this.inOut)
        .then((response) => {
            this.placeList = response.data;
        })
        .catch(() => {
            this.$alert('알림', '2단계 카테고리 데이터를 가져올 수 없습니다.');
        });

    },
    methods:{
        ...mapActions('category', [
            'requestGetPlaceListByInOut'
        ]),
        ...mapActions('product', [
            'requestProductBySubCategory'
        ]),
        show(){
            this.$modal.show('modal-home-category-step2')
        },
        beforeOpen(){
        },
        closed(){
            this.$emit('modal-closed', this.$options.name, {result: this.modalResult})
        },
        selectPlaceCategory(idx){
            var index = this.selectedPlaceList.indexOf(idx); 
			if (index > -1) {
				this.selectedPlaceList.splice(index, 1);
			} else {
                this.selectedPlaceList.push(idx);
            }
        },
        getProduct(){
            var categories = "";
            for(var i = 0; i < this.selectedPlaceList.length; i++){
                categories += this.selectedPlaceList[i] + ","
            }

            if(categories === ""){
                categories = "0"
            }

            this.requestProductBySubCategory({
                currentPage: this.currentPage,
                perPage: this.perPage,
                sortBy: this.sortBy,
                sortDesc: this.sortDesc,
                categories : categories
            })
            .then((result) => {
                if(result.status === 200){

                    this.items = result.data.items;
                    this.totalCnt = result.data.totalCnt;

                    if(this.items == null){
                        this.items = [];
                        this.totalCnt = 0;
                    }
                }
                else{
                    this.$alert('알림', '데이터를 가져올 수 없습니다.')      
                }
            })
            .catch(() => {
                this.$alert('알림', '통신을 실패했습니다.')  
            })
        },
        onClickPagenation (pageNum) {
            this.currentPage = pageNum;
            this.getProduct();
        },
        getManufactureText(value){
            if(value === 'DOMESTIC') return '국내'
            else if(value === 'OVERSEAS') return '해외'
            else return value
        }
    }
}
</script>